/**
 * What the dashboard still needs to know about the print cart.
 *
 * The cart itself lives in the CheckoutApp now — building a line, pricing it, shipping, payment and
 * confirmation all happen inside the <mcs-checkout> embed against its own API. What is left here is
 * the little the dashboard shows around that: the header badge's count, whether a project is
 * already in the cart, reordering a past job, and the promotional product catalogue.
 *
 * The count has two sources. getCartCount fetches it on load; after that the embed pushes changes
 * out as a DOM event and utils/customEventHandler.js commits SET_CART_COUNT, so the badge tracks a
 * cart this store never sees the contents of.
 */

const state = () => ({
  cart: {},
  cart_count: null,
  promo_products: []
});

const getters = {
  cart: (state) => {
    return state.cart || {};
  },
  cart_lines: (state, getters) => {
    return getters.cart.lines || [];
  },
  cart_count: (state) => {
    return state.cart_count ?? 0;
  },
  promo_products(state) {
    return state.promo_products || [];
  }
};

const mutations = {
  SET_CART(state, cart) {
    state.cart = cart;
    state.cart_count = (cart?.lines?.length ?? 0) + (cart?.promoLines?.length ?? 0);
  },
  SET_CART_COUNT(state, count) {
    state.cart_count = count;
  },
  SET_PROMO_PRODUCTS(state, list) {
    state.promo_products = list;
  }
};

const actions = {
  getCartCount({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('printcart/getPrintCartCount')
        .then((response) => {
          commit('SET_CART_COUNT', response.data.count);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async reorder({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`printcart/reorder?jobId=${req.jobId}&isPromo=${req.isPromo}`)
        .then((response) => {
          if (response.data.success) {
            commit('SET_CART', response.data.cart);
          }
          resolve(response.data);
        })
        .catch((error) => {
          reject(new Error(error));
        });
    });
  },
  async getPromoProducts({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('printcart/getPromoProducts')
        .then((response) => {
          commit('SET_PROMO_PRODUCTS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
